import {apiTickersRequests} from '#/repository/api-tickers-requests';
import {shouldWaitlistNetDisplayNullUserAssets} from '#/utils/should-waitlist-net-display-null-user-assets';
import {useQuery} from '@tanstack/react-query';
import {GraphRange, Hex, PortfolioTickerEntry} from 'shareland-common';

export const usePortfolioTicker = (graphRange: GraphRange, account: Hex) =>
  useQuery({
    queryKey: ['portfolio-ticker', graphRange, account],
    queryFn: () =>
      shouldWaitlistNetDisplayNullUserAssets(account!)
        ? ([] as PortfolioTickerEntry[])
        : apiTickersRequests.getPortfolioTicker({graphRange, account}),
  });
